import React, { useState } from 'react';
import { Send, Sliders} from 'lucide-react';

import FinanceiroEstornoFormulario from './FinanceiroEstornoFormulario';
import FinanceiroEstornoControle from './FinanceiroEstornoControle';

const FinanceiroEstorno = ({ subInicial, statusInicial }) => {
    // subInicial/statusInicial vêm do deep-link da Home (pendência de estorno):
    // abre já em "Controle" filtrado pelo status. Sem param, mantém o padrão.
    // Recupera o usuário logado para aplicar travas de menu
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userRole = user?.perfil || '';

    // Perfil 'Auditoria' é SOMENTE LEITURA no Estorno: não solicita estorno,
    // só consulta o Controle (o backend também barra a escrita — isto aqui é UX).
    const somenteLeitura = userRole === 'Auditoria';

    const [activeSubTab, setActiveSubTab] = useState(subInicial || (somenteLeitura ? 'controle' : 'enviar'));

    const renderSubTab = () => {
        switch(activeSubTab) {
            case 'enviar': return somenteLeitura ? <FinanceiroEstornoControle statusInicial={statusInicial} /> : <FinanceiroEstornoFormulario />;
            case 'controle': return <FinanceiroEstornoControle statusInicial={statusInicial} />;
            default: return somenteLeitura ? <FinanceiroEstornoControle statusInicial={statusInicial} /> : <FinanceiroEstornoFormulario />;
        }
    };

    const tabStyle = (isActive) => ({
        display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 20px',
        backgroundColor: isActive ? '#e0f2f1' : 'transparent',
        color: isActive ? '#16a39c' : '#64748b',
        border: 'none', borderRadius: '8px', fontWeight: '600', cursor: 'pointer',
        transition: 'all 0.2s', fontSize: '14px'
    });

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
            {/* SUB-MENU DO PETTY CASH */}
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', borderBottom: '1px solid #e2e8f0', paddingBottom: '16px' }}>
                {!somenteLeitura && (
                    <button onClick={() => setActiveSubTab('enviar')} style={tabStyle(activeSubTab === 'enviar')}>
                        <Send size={18} /> Solicitar Estorno
                    </button>
                )}

                <button onClick={() => setActiveSubTab('controle')} style={tabStyle(activeSubTab === 'controle')}>
                    <Sliders size={18} /> Controle
                </button>
            </div>

            {/* CONTEÚDO DA ABA SELECIONADA */}
            <div style={{ paddingTop: '8px' }}>
                {renderSubTab()}
            </div>
        </div>
    );
};

export default FinanceiroEstorno;